'use client';

import React from 'react';
import { Link } from '@heroui/react';
import { useTranslations } from '../../../../contexts/translation.context';
import { RevshareCost } from '../types';

interface AmountCellProps {
  cost: RevshareCost;
}

const AmountCell: React.FC<AmountCellProps> = ({ cost }) => {
  const { t } = useTranslations();

  return (
    <div className="flex flex-col gap-1">
      {/* Amount row */}
      <div className="flex items-center gap-1">
        <span className="text-auth-muted text-sm font-normal">
          {t('partner.revshare.costs.amount')}:
        </span>
        <span className="text-auth-ink text-sm font-medium">${cost.amount.toFixed(2)}</span>
      </div>
      {/* Transaction URL row - only show if transaction_url exists */}
      {cost.transaction_url && (
        <div className="flex items-center gap-1 bg-auth-surface rounded-2 px-2 py-0.5">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.5 10.5C7.5 10.5 8.25 11.25 9 11.25C9.75 11.25 10.5 10.5 10.5 10.5L12.75 8.25C13.5784 7.42157 13.5784 6.07843 12.75 5.25C11.9216 4.42157 10.5784 4.42157 9.75 5.25L9.375 5.625M10.5 7.5C10.5 7.5 9.75 6.75 9 6.75C8.25 6.75 7.5 7.5 7.5 7.5L5.25 9.75C4.42157 10.5784 4.42157 11.9216 5.25 12.75C6.07843 13.5784 7.42157 13.5784 8.25 12.75L8.625 12.375"
              stroke="#006FEE"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <Link
            href={cost.transaction_url}
            target="_blank"
            className="text-partner text-sm font-normal truncate max-w-[12.5rem]"
          >
            {cost.transaction_url}
          </Link>
        </div>
      )}
    </div>
  );
};

export default AmountCell;
